<template>
  <!-- 手机广告 -->
  <div class="mobile">
    <div class="mobile_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small" id="myform">
          <el-form-item label="频道">
            <el-select
              placeholder="请选择"
              v-model="searchData.menuId"
              clearable
            >
              <el-option
                v-for="item in menuDas"
                :key="item.id"
                :label="item.menuName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否过审">
            <el-select
              v-model="searchData.examineStatus"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in examineDas"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item>
              <el-button
                style="margin-left: 120px"
                type="primary"
                @click="mobileSearch"
                v-if="menuPerm('ad:list')"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="mobileAdd"
                v-if="menuPerm('ad:insert')"
                >添加</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="mobileClear">清空</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-card>
      <el-card>
        <el-table
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          :data="modileList"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <el-table-column
            label="app图片"
            prop="imgUrl"
            width="200px"
            height="200px"
            align="center"
          >
          <template slot-scope="{ row }">
            <viewer :images="photo">
              <img
                :src="row.imgUrl"
                :key="row.id"
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
          </el-table-column>
      
          <el-table-column
            label="类型"
            prop="type"
            width="100px"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.type==1">图片</span>
              <span v-if="row.type==2">视频</span>
              <span v-if="row.type==16">第三方广告</span>
            </template>
          </el-table-column>

           <el-table-column
            label="信息流位置"
            prop="location"
            width="100px"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.location==1">第一信息流</span>
              <span v-if="row.location==2">第二信息流</span>
              <span v-if="row.location==3">第三信息流</span>
              <span v-if="row.location==4">第四信息流</span>
              <span v-if="row.location==5">第五信息流</span>
              <span v-if="row.location==6">第六信息流</span>
              <span v-if="row.location==7">第七信息流</span>
              <span v-if="row.location==8">第八信息流</span>
              <span v-if="row.location==9">第九信息流</span>
              <span v-if="row.location==10">第十信息流</span>
            </template>
          </el-table-column>

          <el-table-column
            label="标题"
            prop="title"
            align="center"
          ></el-table-column>
          <el-table-column
            label="图片跳转链接or视频地址"
            prop="linkTo"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <el-button
                @click="copy"
                type="primary"
                class="btns"
                 size="mini"
                :data-clipboard-text="row.linkTo"
                style="margin-top: 5px;width:80px"
                :disabled="row.linkTo==''||row.linkTo==null"
                >复制</el-button
              >
            </template>
          </el-table-column>

          <el-table-column
            label="开始时间"
            prop="startDate"
            align="center"
            width="150px"
          ></el-table-column>
          <el-table-column
            label="结束时间"
            prop="endDate"
            align="center"
            width="150px"
          ></el-table-column>
          <el-table-column prop="menuId" label="频道" align="center">
            <template slot-scope="{ row }">
              <div v-for="(item, index) in menuDas" :key="index">
                <span v-if="item.id == row.menuId">{{ item.menuName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="是否过审"
            prop="examineStatus"
            align="center"
            width="150px"
            v-if="menuPerm('ad:review')"
          >
            <template slot-scope="{ row }">
              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                @change="examChange(row.id, row.examineStatus)"
              >
                <el-option
                  v-for="item in examineDas"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="是否分享"
            prop="shareFlag"
            width="120px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.shareFlag == 0">
                <el-button size="mini" type="danger" v-if="row.shareFlag == 0"
                  >否</el-button
                >
              </div>
              <div v-if="row.shareFlag == 1">
                <el-button size="mini" type="success" v-if="row.shareFlag == 1"
                  >是</el-button
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="140px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  type="primary"
                  @click="mobileDel(row.id)"
                  class="dels"
                  v-if="menuPerm('ad:delete')"
                  >删除</el-button
                >
                <el-button
                  type="primary"
                  @click="mobileEdit(row.id)"
                  v-if="menuPerm('ad:update')"
                  >修改</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <!-- 详情页面 -->
      <a-drawer
        title="手机广告详情"
        :width="900"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Detail :Detaildata="detailData" />
      </a-drawer>

      <!-- 删除弹框 -->
      <a-modal
        title
        :visible="delOpen"
        @ok="handleOk"
        ok-text="确认"
        cancel-text="取消"
        @cancel="handleCancel"
      >
        <p>确认删除吗？</p>
      </a-modal>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import Detail from "./detail";
export default {
  data() {
    return {
      detailData: "",
      visible: false,
      modileList: [], //手机广告的数据
      photo:[],
      delOpen: false, //删除弹框
      delId: "", //删除id
      currentPage: 1,
      pagesize: 10,
      pageNum: 1,
      totalCount: 0,
      menuDas: "", //频道的数据
      //查询的数据：
      searchData: {
        isRecommend: "", //是否首页
        menuId: "", //频道
        showPosition: "", //信息流展示
        isRotation: "", //本频道轮播
        isHomeRotation: "", //广告图片类型
        examineStatus: "", //是否过审
      },
      //审核状态--下拉框：
      examineDas: [
        {
          label: "通过审核",
          value: 1,
        },
        {
          label: "未通过审核",
          value: 0,
        },
      ],

      //   是否上首页：--下拉框
      homeIn: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],

      //当前频道轮播:--下拉框
      viewLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      //首页轮播--下拉框：
      homeLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      //   信息流展示：--下拉框
      messDas: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
    };
  },
  components: {
    Detail,
  },
  methods: {
    onClose() {
      this.visible = false;
      this.getModile();
    },
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        // this.$message.error({
        //   message: "该浏览器不支持自动复制",
        //   type: "warning"
        // });
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getModile();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getModile();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //查询：
    mobileSearch() {
      this.currentPage = 1;
      this.postAxios("/ad/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        isRecommend: this.searchData.isRecommend, //是否上推荐首页
        menuId: this.searchData.menuId, //频道
        showPosition: this.searchData.showPosition, //是否页面显示
        examineStatus: this.searchData.examineStatus, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.modileList = res.content;
          this.totalCount = res.totalCount;

          // 时间戳转时间：
          this.modileList.map((i, index) => {
            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.modileList[index], `sort`, reviewTimestampsd);
            } else {
              this.$set(this.modileList[index], `sort`, "");
            }
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //添加：
    mobileAdd() {
      this.$router.push({ path: "/mobileAdd" });
    },
    //手机广告删除：
    mobileDel(id) {
      this.delId = id;
      this.delOpen = true;
    },
    handleOk() {
      this.getAxios("/ad/delete", {
        id: this.delId,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("删除成功！");
          this.getModile();
          this.delOpen = false;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    handleCancel() {
      this.delOpen = false;
    },

    //手机广告编辑：
    mobileEdit(id) {
      this.visible = true;
      this.detailData = id;
    },

    //查询清空：
    mobileClear() {
      this.searchData.isRecommend = ""; //是否上推荐首页
      this.searchData.menuId = ""; //频道
      this.searchData.showPosition = ""; //是否页面显示
      this.searchData.examineStatus = ""; //审核状态
    },
    //审核接口：
    examChange(ids, examStatus) {
      this.getAxios("/ad/review", {
        id: ids,
        examineStatus: examStatus,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("审核修改成功");
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },

    //获取手机广告的列表数据
    getModile() {
      this.postAxios("/ad/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        isRecommend: this.searchData.isRecommend, //首页信息流
        menuId: this.searchData.menuId, //频道
        showPosition: this.searchData.showPosition, //当前频道信息流
        examineStatus: this.searchData.examineStatus, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.modileList = res.content;
          this.totalCount = res.totalCount;
          // 时间戳转时间：
          this.modileList.map((i, index) => {
            if (i.sort != null && i.sort != 0) {
              var timeTrans = new Date(parseInt(i.sort) * 1000);
              let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
                hour12: false,
              });
              this.$set(this.modileList[index], `sort`, reviewTimestampsd);
            } else {
              this.$set(this.modileList[index], `sort`, "");
            }
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //频道下拉框数据：
    getPosition() {
      this.getAxios("/menu/list").then((res) => {
        if (res.success == true) {
          this.menuDas = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
  },
  created() {
    this.getModile(); //获取手机广告的列表数据
    this.getPosition(); //频道下拉框数据
  },
};
</script>
<style scoped lang="less">
.mobile {
  width: 100%;
  height: 100%;
  .mobile_box {
    width: 95%;
    height: 100%;
    margin: 20px auto;
    .el-card {
      margin-top: 20px;
      .moblie_img {
        width: 200px;
        height: 150px;
        margin-left: -10px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
      .done {
        display: flex;
        flex-direction: column;
        width: 100px;
        .dels {
          width: 50px;
        }
        /deep/ .el-button--primary {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
          width: 100px;
          margin-top: 10px;
          margin-left: 10px;
          height: 30px;
          line-height: 5px;
          font-size: 12px;
        }
      }
      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
      }
      .link_text {
        display: block;
        width: 200px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      /deep/ .btns {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 30px;
      }
    }
  }
}
</style>